const { formatMoney } = window.BAO.Utils

class IWishlist extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.observeDrawer()

    this.updateWishlistCount()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        closeEl.addEventListener('click', this.onClose.bind(this))
      })
    }

    if (this.externalEls?.['swap-to-cart']?.exists) {
      this.externalEls['swap-to-cart'].elements.forEach(swapToCartEl => {
        swapToCartEl.addEventListener('click', this.onSwapToCart.bind(this))
      })
    }

    if (this.externalEls?.['swap-to-wishlist']?.exists) {
      this.externalEls['swap-to-wishlist'].elements.forEach(
        swapToWishlistEl => {
          swapToWishlistEl.addEventListener(
            'click',
            this.onSwapToWishlist.bind(this),
          )
        },
      )
    }

    if (
      document.querySelector('.iWishAdd') ||
      document.querySelector('.iWishAddColl')
    ) {
      document
        .querySelectorAll('.iWishAdd, .iWishAddColl')
        .forEach(addToWishlistEl => {
          addToWishlistEl.addEventListener('click', () => {
            window.setTimeout(() => {
              this.updateWishlistCount()
            }, 500)
          })
        })
    }
  }

  updateWishlistCount () {
    if (this.externalEls?.count?.exists && typeof Storage !== 'undefined') {
      this.externalEls.count.elements.forEach(countEl => {
        const count =
          typeof localStorage.iWishCnt !== 'undefined'
            ? localStorage.iWishCnt
            : ''
        countEl.dataset.count = count
        countEl.innerHTML = count
      })
    }
  }

  onSwapToCart () {
    if (document.querySelector('.iwish-backdrop')) {
      document.querySelector('.iwish-backdrop').click()
    }

    if (!document.body.classList.contains('drw-Drawers-cart')) {
      document
        .querySelector('.drw-Drawers')
        .classList.add('drw-Drawers-noTransition')

      if (document.querySelector('[data-drawers-trigger="cart"]')) {
        document.querySelector('[data-drawers-trigger="cart"]').click()
      }

      window.setTimeout(() => {
        document
          .querySelector('.drw-Drawers')
          .classList.remove('drw-Drawers-noTransition')
      }, 300)
    }
  }

  onSwapToWishlist () {
    document
      .querySelector('.drw-Drawers')
      .classList.add('drw-Drawers-noTransition')

    window.setTimeout(() => {
      if (document.querySelector('[data-drawers-close]')) {
        document.querySelector('[data-drawers-close]').click()
      }

      document.body.classList.add('util-SiteOverflowed')
    }, 1000)

    window.setTimeout(() => {
      document
        .querySelector('.drw-Drawers')
        .classList.remove('drw-Drawers-noTransition')

      document.body.classList.add('util-SiteOverflowed')
    }, 1100)
  }

  onClose () {
    if (document.querySelector('.iwish-backdrop')) {
      document.querySelector('.iwish-backdrop').click()

      document.body.classList.remove('util-SiteOverflowed')
    }
  }

  setDrawerState () {
    if (document.querySelector('.react-side-draw')) {
      const wishlistDrawer = document.querySelector('.react-side-draw')

      if (wishlistDrawer.classList.contains('open')) {
        document.body.classList.add('util-SiteOverflowed')
      }
    }
  }

  removeWishlist () {
    if (document.querySelector('.trash-btn')) {
      document.querySelector('.trash-btn').click()
    }
  }

  observeDrawer () {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          if (mutation.addedNodes[i].classList !== undefined) {
            if (mutation.addedNodes[i].classList.contains('iwish-backdrop')) {
              this.addHeader()
              this.addFooter()
              this.addMobileBody()
              this.setDrawerState()

              if (document.querySelector('.iwish-backdrop')) {
                document
                  .querySelectorAll('.iwish-backdrop')
                  .forEach(backdropEl => {
                    backdropEl.addEventListener('click', () => {
                      this.onClose()
                    })
                  })
              }
            }

            if (mutation.addedNodes[i].classList.contains('iwishProduct-row')) {
              this.replaceCartText()
              this.updatePrices()

              if (document.querySelector('.trash-btn')) {
                document
                  .querySelectorAll('.trash-btn')
                  .forEach(removeFromWishlistEl => {
                    removeFromWishlistEl.addEventListener('click', () => {
                      window.setTimeout(() => {
                        this.updateWishlistCount()
                      }, 500)
                    })
                  })
              }

              if (document.querySelector('.cart-btn')) {
                document.querySelectorAll('.cart-btn').forEach(addToCartEl => {
                  addToCartEl.addEventListener('click', () => {
                    const variantId = addToCartEl
                      .closest('.iwishProduct-row')
                      .id.replace('transfer_', '')

                    window.setTimeout(() => {
                      this.removeWishlist()
                      this.updateWishlistCount()
                      this.updatePushcart()
                      this.onSwapToCart()
                    }, 500)

                    window.setTimeout(() => {
                      if (
                        variantId &&
                        document.querySelector(
                          `[data-variant-select="${variantId}"]`,
                        )
                      ) {
                        document
                          .querySelector(`[data-variant-select="${variantId}"]`)
                          .focus()
                      }
                    }, 1000)
                  })
                })
              }
            }
          }
        }
      })
    })

    observer.observe(document.querySelector('#mst-iwish-drawer-root'), {
      childList: true,
      subtree: true,
    })
  }

  replaceCartText () {
    if (document.querySelector('.cart-btn')) {
      document.querySelectorAll('.cart-btn').forEach(cartBtnEl => {
        cartBtnEl.textContent = cartBtnEl.textContent.replace('Cart', 'Bag')
      })
    }
  }

  async updatePushcart () {
    const { pushCartSections, wishlistSections } = window.BAO.sectionRenderer

    const sectionHtml = await window.BAO.sectionRenderer.fetch(
      pushCartSections.map(s => s.section),
    )

    window.BAO.sectionRenderer.renderMultiple(
      pushCartSections.map(s =>
        Object.assign({}, s, { html: sectionHtml[s.section] }),
      ),
    )

    const wishlistSectionHtml = await window.BAO.sectionRenderer.fetch(
      wishlistSections.map(s => s.section),
    )

    window.BAO.sectionRenderer.renderMultiple(
      wishlistSections.map(s =>
        Object.assign({}, s, { html: wishlistSectionHtml[s.section] }),
      ),
    )
  }

  updatePrices () {
    if (document.querySelector('.react-side-draw .iwishProduct-row span.m-0')) {
      document
        .querySelectorAll('.react-side-draw .iwishProduct-row span.m-0')
        .forEach(priceEl => {
          let priceInt = Number(priceEl.textContent.replace(/[^0-9.-]+/g, ''))

          // Add VIP pricing
          if (window.BAO.discount > 0) {
            if (window.Shopify.currency.active === 'EUR') {
              // Change format for EUR
              priceInt = Number(
                priceEl.textContent.replace('.', '').replace(/[^0-9.-]+/g, ''),
              )

              const discountRate = (100 - window.BAO.discount) / 100
              const discountedPrice = priceInt * discountRate

              priceEl.textContent = `${formatMoney(priceInt)
                .replace('.00', '')
                .replace(',', ' ')} ${window.Shopify.currency.active}`
              priceEl.dataset.price = `${formatMoney(discountedPrice)
                .replace('.00', '')
                .replace(',', ' ')} ${window.Shopify.currency.active}`
            } else {
              const cents = priceInt * 100

              const discountRate = (100 - window.BAO.discount) / 100
              const discountedPrice = cents * discountRate

              priceEl.textContent = priceEl.textContent = `${formatMoney(cents)
                .replace('.00', '')
                .replace(',', ' ')} ${window.Shopify.currency.active}`
              priceEl.dataset.price = `${formatMoney(discountedPrice)
                .replace('.00', '')
                .replace(',', ' ')} ${window.Shopify.currency.active}`
            }
          } else if (window.Shopify.currency.active === 'EUR') {
            // Change format for EUR
            priceInt = Number(
              priceEl.textContent.replace('.', '').replace(/[^0-9.-]+/g, ''),
            )

            priceEl.textContent = `${formatMoney(priceInt)
              .replace('.00', '')
              .replace(',', ' ')} ${window.Shopify.currency.active}`
          } else {
            const cents = priceInt * 100

            priceEl.textContent = `${formatMoney(cents)
              .replace('.00', '')
              .replace(',', ' ')} ${window.Shopify.currency.active}`
          }
        })
    }
  }

  addHeader () {
    if (this?.els?.header?.exists) {
      const container = document.querySelector('.react-side-draw')
      container.insertBefore(this.els.header.element, container.firstChild)
    }
  }

  addFooter () {
    if (this?.els?.footer?.exists) {
      const container = document.querySelector('.react-side-draw')
      container.appendChild(this.els.footer.element)
    }
  }

  addMobileBody () {
    if (this?.els?.mobilebody?.exists) {
      const container = document.querySelector('.product-wrapper')
      container.insertBefore(this.els.mobilebody.element, container.firstChild)
    }
  }
}

if (!customElements.get('i-wishlist')) {
  customElements.define('i-wishlist', IWishlist)
}
